import React from "react";
import { DetailsPopup } from "modules/common/components/form/DetailsPopup";
import { Block } from "modules/common/components/page/Block";
import { matchRoute } from "modules/common/services/routing";
import { WhenPath } from "modules/common/components/routing/WhenPath";
import { routes } from "modules/common/routes";
import { observer } from "mobx-react";
import { texts } from "modules/common/texts";
import { EMPTY_OBJECT_ID } from "modules/common/constants";
import { OrderTypesStoreType } from "../models/order-types-store";
import { OrderTypeDetails } from "./details/OrderTypeDetails";
import { OrderTypesList } from "./list/OrderTypesList";
import { menuItems } from "modules/root/components/menu/MainMenu";
import func from "modules/dictionaries/functionalities";
import { can } from "modules/session/auth/access";

import styles from "./OrderTypesPage.module.scss";
import { PlanrButton } from "modules/common/components/planr/button/Button";
import { Search } from "modules/common/components/form/Search";
import { withNavigation, NavigationProps, type Location } from "modules/common/components/routing/withNavigation";

const menu = menuItems();

class OrderTypesPage extends React.Component<OrderTypesPageProps & NavigationProps, OrderTypesPageState> {
  constructor(props: OrderTypesPageProps & NavigationProps) {
    super(props);

    this.state = { typeId: getSelectedOrderTypeId(props.location.pathname) };
  }

  componentDidMount() {
    document.title = menu.dictionaries.nested.orderTypes.label;

    const { typeId } = this.state;

    this.loadList();
    this.loadDetails(typeId);
  }

  componentDidUpdate(prevProps: NavigationProps) {
    // смена адреса приходит новым location в пропах
    if (prevProps.location !== this.props.location) {
      this.onLocationChanged(this.props.location);
    }
  }

  onLocationChanged = (location: Location) => {
    const typeId = getSelectedOrderTypeId(location.pathname);

    if (this.state.typeId !== typeId) {
      this.setState({ typeId });
      this.loadDetails(typeId);
    }
  };

  render() {
    const { store, access } = this.props;
    const canChange = can(func.ORDERTYPE_EDIT, access);

    return (
      <Block columned={true} className={styles.page}>
        <WhenPath path={routes.dictionaries.orderType.details()}>
          <DetailsPopup title="Тип договора" onCancel={this.onOrderTypeSelected}>
            <OrderTypeDetails
              canChange={canChange}
              orderType={store.details}
              onSaved={this.onOrderTypeSaved}
              onRemoved={this.onOrderTypeRemoved}
            />
          </DetailsPopup>
        </WhenPath>
        <div className={styles.tools}>
          {" "}
          {
            canChange && (
              <PlanrButton
                type="secondary"
                size="small"
                icon="general-plus-big"
                onClick={this.onOrderTypeAdd}
                style={{
                  width: "250px",
                  marginBottom: "32px",
                  borderRadius: "120px",
                }}
              >{`${texts.add} тип договора`}</PlanrButton>
            )

            // <DictioantyAddButton onClick={this.onOrderTypeAdd} label={`${texts.add} тип договора`} />
          }
        </div>
        <div className={styles.mobileTools}>
          {canChange && <PlanrButton type="secondary" round icon="general-plus-big" onClick={this.onOrderTypeAdd} />}
        </div>
        <div className={styles.right}>
          <Search query={store.list.query} onSearch={store.list.setQuery} />
        </div>
        <OrderTypesList store={store.list} onSelected={this.onOrderTypeSelected} onRemoved={this.onOrderTypeRemoved} />
      </Block>
    );
  }

  onOrderTypeAdd = () => {
    this.onOrderTypeSelected(EMPTY_OBJECT_ID);
  };

  onOrderTypeSelected = (id: string = "") => {
    const { navigate } = this.props;

    const url = id ? routes.dictionaries.orderType.details(id) : routes.dictionaries.orderType.path;

    navigate(url);
  };

  onOrderTypeSaved = () => {
    this.onOrderTypeSelected("");
    this.loadList();
  };

  onOrderTypeRemoved = () => {
    const { navigate } = this.props;

    this.loadList();

    const url = routes.dictionaries.orderType.path;
    navigate(url);
  };

  loadList = () => this.props.store.list.load();

  loadDetails = (id: string) => this.props.store.details.load(id);
}

export default withNavigation(observer(OrderTypesPage));

function getSelectedOrderTypeId(pathname: string) {
  const match = matchRoute<OrderTypesPageState>(pathname, routes.dictionaries.orderType.details());

  return match && match.params ? match.params.typeId : "";
}

interface OrderTypesPageProps {
  store: OrderTypesStoreType;
  access: string[];
}

interface OrderTypesPageState {
  typeId: string;
}
